import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './PageShared.css';
import './NotFound.css';

export default function NotFound() {
  return (
    <main className="page">
      <SEO
        title="Siden blev ikke fundet"
        path="/404"
        noindex
        description="Den side du leder efter findes ikke. Gå tilbage til forsiden på Little-Stars."
      />

      <div className="notfound-container">
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">
          Ups! Vi kan ikke finde <span className="gradient-text">den side</span>
        </h2>
        <p className="notfound-desc">
          Siden eksisterer ikke eller er blevet flyttet. Men der er masser af sjov på forsiden!
        </p>
        <Link to="/" className="btn btn-primary btn-lg">
          Gå til forsiden
        </Link>
      </div>
    </main>
  );
}
